// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AppFeedbackCommentData, AppFeedbackCommentErrors, AppFeedbackCommentResponses, AppFeedbackRatingData, AppFeedbackRatingErrors, AppFeedbackRatingResponses, ArchiveFriendByIdData, ArchiveFriendByIdErrors, ArchiveFriendByIdResponses, BlockFriendByIdData, BlockFriendByIdErrors, BlockFriendByIdResponses, BlockUserChatData, BlockUserChatErrors, BlockUserChatResponses, BlockUserData, BlockUserErrors, BlockUserResponses, CreateStreamMessageData, CreateStreamMessageErrors, CreateStreamMessageResponses, DeclineFriendMatchData, DeclineFriendMatchErrors, DeclineFriendMatchResponses, EasyMatchConfirmData, EasyMatchConfirmErrors, EasyMatchConfirmResponses, EasyMatchFeedbackData, EasyMatchFeedbackErrors, EasyMatchFeedbackResponses, EasyMatchFeedbackSkipData, EasyMatchFeedbackSkipErrors, EasyMatchFeedbackSkipResponses, EasyMatchSkipData, EasyMatchSkipErrors, EasyMatchSkipResponses, EasyMatchStartData, EasyMatchStartErrors, EasyMatchStartResponses, FriendInvitationAcceptData, FriendInvitationAcceptErrors, FriendInvitationAcceptResponses, FriendInvitationAddByRefData, FriendInvitationAddByRefErrors, FriendInvitationAddByRefResponses, FriendInvitationCreateData, FriendInvitationCreateErrors, FriendInvitationCreateResponses, FriendInvitationRejectData, FriendInvitationRejectErrors, FriendInvitationRejectResponses, FriendInvitationStatsData, FriendInvitationStatsErrors, FriendInvitationStatsResponses, GetApiV1WsData, GetApiV1WsErrors, GetEasyMatchStatusData, GetEasyMatchStatusErrors, GetEasyMatchStatusResponses, GetSocialMatchStatusData, GetSocialMatchStatusErrors, GetSocialMatchStatusResponses, HideStreamMessageData, HideStreamMessageErrors, HideStreamMessageResponses, LegacyNotificationsData, LegacyNotificationsErrors, LegacyNotificationsLuniData, LegacyNotificationsLuniErrors, LegacyNotificationsLuniResponses, LegacyNotificationsResponses, ListFriendsData, ListFriendsErrors, ListFriendsResponses, ListPendingFriendsData, ListPendingFriendsErrors, ListPendingFriendsResponses, ListStreamData, ListStreamErrors, ListStreamResponses, LuniVoiceMessageDeleteData, LuniVoiceMessageDeleteErrors, LuniVoiceMessageDeleteResponses, LuniVoiceMessageFinishData, LuniVoiceMessageFinishErrors, LuniVoiceMessageFinishResponses, LuniVoiceMessageGetData, LuniVoiceMessageGetErrors, LuniVoiceMessageGetResponses, LuniVoiceMessageHoldData, LuniVoiceMessageHoldErrors, LuniVoiceMessageHoldResponses, LuniVoiceMessagePublishData, LuniVoiceMessagePublishErrors, LuniVoiceMessagePublishResponses, LuniVoiceMessageReleaseData, LuniVoiceMessageReleaseErrors, LuniVoiceMessageReleaseResponses, LuniVoiceMessageUrlData, LuniVoiceMessageUrlErrors, LuniVoiceMessageUrlResponses, NotificationResponseData, NotificationResponseErrors, NotificationResponseResponses, OnlineUsersData, OnlineUsersErrors, OnlineUsersLuniData, OnlineUsersLuniErrors, OnlineUsersLuniResponses, OnlineUsersResponses, OpenFriendMatchData, OpenFriendMatchErrors, OpenFriendMatchResponses, ReportStreamMessageData, ReportStreamMessageErrors, ReportStreamMessageResponses, ScenarioAcceptData, ScenarioAcceptErrors, ScenarioAcceptResponses, ScenarioCurrentData, ScenarioCurrentErrors, ScenarioCurrentResponses, ScenarioPendingData, ScenarioPendingErrors, ScenarioPendingResponses, ScenarioProposeData, ScenarioProposeErrors, ScenarioProposeResponses, SocialMatchConfirmData, SocialMatchConfirmErrors, SocialMatchConfirmResponses, SocialMatchFeedbackData, SocialMatchFeedbackErrors, SocialMatchFeedbackResponses, SocialMatchFeedbackSkipData, SocialMatchFeedbackSkipErrors, SocialMatchFeedbackSkipResponses, SocialMatchLaterData, SocialMatchLaterErrors, SocialMatchLaterResponses, SocialMatchOpenData, SocialMatchOpenErrors, SocialMatchOpenResponses, SocialMatchSkipData, SocialMatchSkipErrors, SocialMatchSkipResponses, StarStreamMessageData, StarStreamMessageErrors, StarStreamMessageResponses, StartSocialMatchData, StartSocialMatchErrors, StartSocialMatchResponses, StreamStatusData, StreamStatusErrors, StreamStatusResponses, SubmitSocialMatchData, SubmitSocialMatchErrors, SubmitSocialMatchResponses, UnarchiveFriendByIdData, UnarchiveFriendByIdErrors, UnarchiveFriendByIdResponses, UnblockFriendByIdData, UnblockFriendByIdErrors, UnblockFriendByIdResponses, UserStatusData, UserStatusErrors, UserStatusLuniData, UserStatusLuniErrors, UserStatusLuniResponses, UserStatusResponses } from './types.gen';
import { zAppFeedbackCommentResponse, zAppFeedbackRatingResponse, zArchiveFriendByIdResponse, zBlockFriendByIdResponse, zBlockUserChatResponse, zBlockUserResponse, zCreateStreamMessageResponse, zDeclineFriendMatchResponse, zEasyMatchConfirmResponse, zEasyMatchFeedbackResponse, zEasyMatchFeedbackSkipResponse, zEasyMatchSkipResponse, zEasyMatchStartResponse, zFriendInvitationAcceptResponse, zFriendInvitationAddByRefResponse, zFriendInvitationCreateResponse, zFriendInvitationRejectResponse, zFriendInvitationStatsResponse, zGetEasyMatchStatusResponse, zGetSocialMatchStatusResponse, zHideStreamMessageResponse, zLegacyNotificationsLuniResponse, zLegacyNotificationsResponse2, zListFriendsResponse, zListPendingFriendsResponse, zListStreamResponse, zLuniVoiceMessageDeleteResponse, zLuniVoiceMessageFinishResponse, zLuniVoiceMessageGetResponse, zLuniVoiceMessageHoldResponse, zLuniVoiceMessagePublishResponse, zLuniVoiceMessageReleaseResponse, zLuniVoiceMessageUrlResponse, zNotificationResponseResponse, zOnlineUsersLuniResponse, zOnlineUsersResponse2, zOpenFriendMatchResponse, zReportStreamMessageResponse, zScenarioAcceptResponse, zScenarioCurrentResponse, zScenarioPendingResponse, zScenarioProposeResponse, zSocialMatchConfirmResponse, zSocialMatchFeedbackResponse, zSocialMatchFeedbackSkipResponse, zSocialMatchLaterResponse, zSocialMatchOpenResponse, zSocialMatchSkipResponse, zStarStreamMessageResponse, zStartSocialMatchResponse, zStreamStatusResponse2, zSubmitSocialMatchResponse, zUnarchiveFriendByIdResponse, zUnblockFriendByIdResponse, zUserStatusLuniResponse, zUserStatusResponse2 } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Block user
 */
export const blockUserChat = <ThrowOnError extends boolean = true>(options: Options<BlockUserChatData, ThrowOnError>): RequestResult<BlockUserChatResponses, BlockUserChatErrors, ThrowOnError, 'data'> => (options.client ?? client).post<BlockUserChatResponses, BlockUserChatErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zBlockUserChatResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/block_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept invitation
 */
export const friendInvitationAccept = <ThrowOnError extends boolean = true>(options: Options<FriendInvitationAcceptData, ThrowOnError>): RequestResult<FriendInvitationAcceptResponses, FriendInvitationAcceptErrors, ThrowOnError, 'data'> => (options.client ?? client).post<FriendInvitationAcceptResponses, FriendInvitationAcceptErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zFriendInvitationAcceptResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/friend_invitation/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add invitation by ref code
 */
export const friendInvitationAddByRef = <ThrowOnError extends boolean = true>(options: Options<FriendInvitationAddByRefData, ThrowOnError>): RequestResult<FriendInvitationAddByRefResponses, FriendInvitationAddByRefErrors, ThrowOnError, 'data'> => (options.client ?? client).post<FriendInvitationAddByRefResponses, FriendInvitationAddByRefErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zFriendInvitationAddByRefResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/friend_invitation/add_by_ref',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create friend invitation
 */
export const friendInvitationCreate = <ThrowOnError extends boolean = true>(options: Options<FriendInvitationCreateData, ThrowOnError>): RequestResult<FriendInvitationCreateResponses, FriendInvitationCreateErrors, ThrowOnError, 'data'> => (options.client ?? client).post<FriendInvitationCreateResponses, FriendInvitationCreateErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zFriendInvitationCreateResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/friend_invitation/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject invitation
 */
export const friendInvitationReject = <ThrowOnError extends boolean = true>(options: Options<FriendInvitationRejectData, ThrowOnError>): RequestResult<FriendInvitationRejectResponses, FriendInvitationRejectErrors, ThrowOnError, 'data'> => (options.client ?? client).post<FriendInvitationRejectResponses, FriendInvitationRejectErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zFriendInvitationRejectResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/friend_invitation/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invitation attempts stats
 */
export const friendInvitationStats = <ThrowOnError extends boolean = true>(options?: Options<FriendInvitationStatsData, ThrowOnError>): RequestResult<FriendInvitationStatsResponses, FriendInvitationStatsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<FriendInvitationStatsResponses, FriendInvitationStatsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zFriendInvitationStatsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/friend_invitation/stats',
    ...options
});

/**
 * Submit app feedback comment
 */
export const appFeedbackComment = <ThrowOnError extends boolean = true>(options: Options<AppFeedbackCommentData, ThrowOnError>): RequestResult<AppFeedbackCommentResponses, AppFeedbackCommentErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AppFeedbackCommentResponses, AppFeedbackCommentErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAppFeedbackCommentResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/app_feedback/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit app rating (1..5)
 */
export const appFeedbackRating = <ThrowOnError extends boolean = true>(options: Options<AppFeedbackRatingData, ThrowOnError>): RequestResult<AppFeedbackRatingResponses, AppFeedbackRatingErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AppFeedbackRatingResponses, AppFeedbackRatingErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAppFeedbackRatingResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/app_feedback/rating',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Block user
 */
export const blockUser = <ThrowOnError extends boolean = true>(options: Options<BlockUserData, ThrowOnError>): RequestResult<BlockUserResponses, BlockUserErrors, ThrowOnError, 'data'> => (options.client ?? client).post<BlockUserResponses, BlockUserErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zBlockUserResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/block_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start easy match search
 */
export const easyMatchStart = <ThrowOnError extends boolean = true>(options: Options<EasyMatchStartData, ThrowOnError>): RequestResult<EasyMatchStartResponses, EasyMatchStartErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EasyMatchStartResponses, EasyMatchStartErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEasyMatchStartResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/easy_match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm easy match
 */
export const easyMatchConfirm = <ThrowOnError extends boolean = true>(options: Options<EasyMatchConfirmData, ThrowOnError>): RequestResult<EasyMatchConfirmResponses, EasyMatchConfirmErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EasyMatchConfirmResponses, EasyMatchConfirmErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEasyMatchConfirmResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/easy_match/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit easy match feedback for a 5-match series
 */
export const easyMatchFeedback = <ThrowOnError extends boolean = true>(options: Options<EasyMatchFeedbackData, ThrowOnError>): RequestResult<EasyMatchFeedbackResponses, EasyMatchFeedbackErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EasyMatchFeedbackResponses, EasyMatchFeedbackErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEasyMatchFeedbackResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/easy_match/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip easy match feedback survey
 */
export const easyMatchFeedbackSkip = <ThrowOnError extends boolean = true>(options: Options<EasyMatchFeedbackSkipData, ThrowOnError>): RequestResult<EasyMatchFeedbackSkipResponses, EasyMatchFeedbackSkipErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EasyMatchFeedbackSkipResponses, EasyMatchFeedbackSkipErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEasyMatchFeedbackSkipResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/easy_match/feedback/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip easy match candidate
 */
export const easyMatchSkip = <ThrowOnError extends boolean = true>(options: Options<EasyMatchSkipData, ThrowOnError>): RequestResult<EasyMatchSkipResponses, EasyMatchSkipErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EasyMatchSkipResponses, EasyMatchSkipErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEasyMatchSkipResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/easy_match/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Easy match status
 */
export const getEasyMatchStatus = <ThrowOnError extends boolean = true>(options?: Options<GetEasyMatchStatusData, ThrowOnError>): RequestResult<GetEasyMatchStatusResponses, GetEasyMatchStatusErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetEasyMatchStatusResponses, GetEasyMatchStatusErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetEasyMatchStatusResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/easy_match/status',
    ...options
});

/**
 * List friends
 */
export const listFriends = <ThrowOnError extends boolean = true>(options?: Options<ListFriendsData, ThrowOnError>): RequestResult<ListFriendsResponses, ListFriendsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ListFriendsResponses, ListFriendsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zListFriendsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/friends',
    ...options
});

/**
 * Archive friend by id
 */
export const archiveFriendById = <ThrowOnError extends boolean = true>(options: Options<ArchiveFriendByIdData, ThrowOnError>): RequestResult<ArchiveFriendByIdResponses, ArchiveFriendByIdErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ArchiveFriendByIdResponses, ArchiveFriendByIdErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zArchiveFriendByIdResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/friends/{friend_id}/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Block friend by id
 */
export const blockFriendById = <ThrowOnError extends boolean = true>(options: Options<BlockFriendByIdData, ThrowOnError>): RequestResult<BlockFriendByIdResponses, BlockFriendByIdErrors, ThrowOnError, 'data'> => (options.client ?? client).post<BlockFriendByIdResponses, BlockFriendByIdErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zBlockFriendByIdResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/friends/{friend_id}/block',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decline New-tab match
 */
export const declineFriendMatch = <ThrowOnError extends boolean = true>(options: Options<DeclineFriendMatchData, ThrowOnError>): RequestResult<DeclineFriendMatchResponses, DeclineFriendMatchErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DeclineFriendMatchResponses, DeclineFriendMatchErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeclineFriendMatchResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/friends/{friend_id}/decline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open New-tab match state
 */
export const openFriendMatch = <ThrowOnError extends boolean = true>(options: Options<OpenFriendMatchData, ThrowOnError>): RequestResult<OpenFriendMatchResponses, OpenFriendMatchErrors, ThrowOnError, 'data'> => (options.client ?? client).post<OpenFriendMatchResponses, OpenFriendMatchErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zOpenFriendMatchResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/friends/{friend_id}/open',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unarchive friend by id
 */
export const unarchiveFriendById = <ThrowOnError extends boolean = true>(options: Options<UnarchiveFriendByIdData, ThrowOnError>): RequestResult<UnarchiveFriendByIdResponses, UnarchiveFriendByIdErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UnarchiveFriendByIdResponses, UnarchiveFriendByIdErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUnarchiveFriendByIdResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/friends/{friend_id}/unarchive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unblock friend by id
 */
export const unblockFriendById = <ThrowOnError extends boolean = true>(options: Options<UnblockFriendByIdData, ThrowOnError>): RequestResult<UnblockFriendByIdResponses, UnblockFriendByIdErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UnblockFriendByIdResponses, UnblockFriendByIdErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUnblockFriendByIdResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/friends/{friend_id}/unblock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record popup notification response telemetry
 */
export const notificationResponse = <ThrowOnError extends boolean = true>(options: Options<NotificationResponseData, ThrowOnError>): RequestResult<NotificationResponseResponses, NotificationResponseErrors, ThrowOnError, 'data'> => (options.client ?? client).post<NotificationResponseResponses, NotificationResponseErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zNotificationResponseResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/notifications/{notification_id}/response',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Legacy board notifications
 */
export const legacyNotificationsLuni = <ThrowOnError extends boolean = true>(options: Options<LegacyNotificationsLuniData, ThrowOnError>): RequestResult<LegacyNotificationsLuniResponses, LegacyNotificationsLuniErrors, ThrowOnError, 'data'> => (options.client ?? client).get<LegacyNotificationsLuniResponses, LegacyNotificationsLuniErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLegacyNotificationsLuniResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/notifications/{user_id}',
    ...options
});

/**
 * Get online users (Luni path)
 */
export const onlineUsersLuni = <ThrowOnError extends boolean = true>(options?: Options<OnlineUsersLuniData, ThrowOnError>): RequestResult<OnlineUsersLuniResponses, OnlineUsersLuniErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<OnlineUsersLuniResponses, OnlineUsersLuniErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zOnlineUsersLuniResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/online-users',
    ...options
});

/**
 * List pending friends
 */
export const listPendingFriends = <ThrowOnError extends boolean = true>(options?: Options<ListPendingFriendsData, ThrowOnError>): RequestResult<ListPendingFriendsResponses, ListPendingFriendsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ListPendingFriendsResponses, ListPendingFriendsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zListPendingFriendsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/pending_friends',
    ...options
});

/**
 * List active scenario proposals for the current user
 */
export const scenarioPending = <ThrowOnError extends boolean = true>(options?: Options<ScenarioPendingData, ThrowOnError>): RequestResult<ScenarioPendingResponses, ScenarioPendingErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ScenarioPendingResponses, ScenarioPendingErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zScenarioPendingResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/scenarios/pending',
    ...options
});

/**
 * Get the current or pending scenario for a friend pair
 */
export const scenarioCurrent = <ThrowOnError extends boolean = true>(options: Options<ScenarioCurrentData, ThrowOnError>): RequestResult<ScenarioCurrentResponses, ScenarioCurrentErrors, ThrowOnError, 'data'> => (options.client ?? client).get<ScenarioCurrentResponses, ScenarioCurrentErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zScenarioCurrentResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/scenarios/{friend_id}',
    ...options
});

/**
 * Accept a pending scenario (continue and decline both accept)
 */
export const scenarioAccept = <ThrowOnError extends boolean = true>(options: Options<ScenarioAcceptData, ThrowOnError>): RequestResult<ScenarioAcceptResponses, ScenarioAcceptErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ScenarioAcceptResponses, ScenarioAcceptErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zScenarioAcceptResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/scenarios/{friend_id}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Propose a scenario with the initiator answer
 */
export const scenarioPropose = <ThrowOnError extends boolean = true>(options: Options<ScenarioProposeData, ThrowOnError>): RequestResult<ScenarioProposeResponses, ScenarioProposeErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ScenarioProposeResponses, ScenarioProposeErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zScenarioProposeResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/scenarios/{friend_id}/propose',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit social match request
 */
export const submitSocialMatch = <ThrowOnError extends boolean = true>(options: Options<SubmitSocialMatchData, ThrowOnError>): RequestResult<SubmitSocialMatchResponses, SubmitSocialMatchErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SubmitSocialMatchResponses, SubmitSocialMatchErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSubmitSocialMatchResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm social match proposal
 */
export const socialMatchConfirm = <ThrowOnError extends boolean = true>(options: Options<SocialMatchConfirmData, ThrowOnError>): RequestResult<SocialMatchConfirmResponses, SocialMatchConfirmErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SocialMatchConfirmResponses, SocialMatchConfirmErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSocialMatchConfirmResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit social match feedback
 */
export const socialMatchFeedback = <ThrowOnError extends boolean = true>(options: Options<SocialMatchFeedbackData, ThrowOnError>): RequestResult<SocialMatchFeedbackResponses, SocialMatchFeedbackErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SocialMatchFeedbackResponses, SocialMatchFeedbackErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSocialMatchFeedbackResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip social match feedback survey
 */
export const socialMatchFeedbackSkip = <ThrowOnError extends boolean = true>(options: Options<SocialMatchFeedbackSkipData, ThrowOnError>): RequestResult<SocialMatchFeedbackSkipResponses, SocialMatchFeedbackSkipErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SocialMatchFeedbackSkipResponses, SocialMatchFeedbackSkipErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSocialMatchFeedbackSkipResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/feedback/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Defer social match requester popup
 */
export const socialMatchLater = <ThrowOnError extends boolean = true>(options: Options<SocialMatchLaterData, ThrowOnError>): RequestResult<SocialMatchLaterResponses, SocialMatchLaterErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SocialMatchLaterResponses, SocialMatchLaterErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSocialMatchLaterResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/later',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open social match from requester popup
 */
export const socialMatchOpen = <ThrowOnError extends boolean = true>(options: Options<SocialMatchOpenData, ThrowOnError>): RequestResult<SocialMatchOpenResponses, SocialMatchOpenErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SocialMatchOpenResponses, SocialMatchOpenErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSocialMatchOpenResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/open',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip social match proposal
 */
export const socialMatchSkip = <ThrowOnError extends boolean = true>(options: Options<SocialMatchSkipData, ThrowOnError>): RequestResult<SocialMatchSkipResponses, SocialMatchSkipErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SocialMatchSkipResponses, SocialMatchSkipErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSocialMatchSkipResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start social match flow (emits WS when blocked by unmessaged friend)
 */
export const startSocialMatch = <ThrowOnError extends boolean = true>(options: Options<StartSocialMatchData, ThrowOnError>): RequestResult<StartSocialMatchResponses, StartSocialMatchErrors, ThrowOnError, 'data'> => (options.client ?? client).post<StartSocialMatchResponses, StartSocialMatchErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zStartSocialMatchResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Social match status
 */
export const getSocialMatchStatus = <ThrowOnError extends boolean = true>(options?: Options<GetSocialMatchStatusData, ThrowOnError>): RequestResult<GetSocialMatchStatusResponses, GetSocialMatchStatusErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetSocialMatchStatusResponses, GetSocialMatchStatusErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetSocialMatchStatusResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/social_match/status',
    ...options
});

/**
 * List public stream messages (oldest first, newest last)
 */
export const listStream = <ThrowOnError extends boolean = true>(options?: Options<ListStreamData, ThrowOnError>): RequestResult<ListStreamResponses, ListStreamErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ListStreamResponses, ListStreamErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zListStreamResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/stream',
    ...options
});

/**
 * Post a public stream message
 */
export const createStreamMessage = <ThrowOnError extends boolean = true>(options: Options<CreateStreamMessageData, ThrowOnError>): RequestResult<CreateStreamMessageResponses, CreateStreamMessageErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CreateStreamMessageResponses, CreateStreamMessageErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateStreamMessageResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hide a stream message for the viewer
 */
export const hideStreamMessage = <ThrowOnError extends boolean = true>(options: Options<HideStreamMessageData, ThrowOnError>): RequestResult<HideStreamMessageResponses, HideStreamMessageErrors, ThrowOnError, 'data'> => (options.client ?? client).post<HideStreamMessageResponses, HideStreamMessageErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zHideStreamMessageResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/stream/messages/{id}/hide',
    ...options
});

/**
 * Report a stream message and hide it for the viewer
 */
export const reportStreamMessage = <ThrowOnError extends boolean = true>(options: Options<ReportStreamMessageData, ThrowOnError>): RequestResult<ReportStreamMessageResponses, ReportStreamMessageErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ReportStreamMessageResponses, ReportStreamMessageErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zReportStreamMessageResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/stream/messages/{id}/report',
    ...options
});

/**
 * Star a stream message once
 */
export const starStreamMessage = <ThrowOnError extends boolean = true>(options: Options<StarStreamMessageData, ThrowOnError>): RequestResult<StarStreamMessageResponses, StarStreamMessageErrors, ThrowOnError, 'data'> => (options.client ?? client).post<StarStreamMessageResponses, StarStreamMessageErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zStarStreamMessageResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/stream/messages/{id}/star',
    ...options
});

/**
 * Whether there are new stream messages since last visit
 */
export const streamStatus = <ThrowOnError extends boolean = true>(options?: Options<StreamStatusData, ThrowOnError>): RequestResult<StreamStatusResponses, StreamStatusErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<StreamStatusResponses, StreamStatusErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zStreamStatusResponse2.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/stream/status',
    ...options
});

/**
 * Get user status
 */
export const userStatusLuni = <ThrowOnError extends boolean = true>(options: Options<UserStatusLuniData, ThrowOnError>): RequestResult<UserStatusLuniResponses, UserStatusLuniErrors, ThrowOnError, 'data'> => (options.client ?? client).get<UserStatusLuniResponses, UserStatusLuniErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUserStatusLuniResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/user-status/{user_id}',
    ...options
});

/**
 * Get the pair voice-slot snapshot
 */
export const luniVoiceMessageGet = <ThrowOnError extends boolean = true>(options: Options<LuniVoiceMessageGetData, ThrowOnError>): RequestResult<LuniVoiceMessageGetResponses, LuniVoiceMessageGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<LuniVoiceMessageGetResponses, LuniVoiceMessageGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLuniVoiceMessageGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/voice/message',
    ...options
});

/**
 * Author deletes the current voice message
 */
export const luniVoiceMessageDelete = <ThrowOnError extends boolean = true>(options: Options<LuniVoiceMessageDeleteData, ThrowOnError>): RequestResult<LuniVoiceMessageDeleteResponses, LuniVoiceMessageDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LuniVoiceMessageDeleteResponses, LuniVoiceMessageDeleteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLuniVoiceMessageDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/voice/message/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recipient finishes the current voice message
 */
export const luniVoiceMessageFinish = <ThrowOnError extends boolean = true>(options: Options<LuniVoiceMessageFinishData, ThrowOnError>): RequestResult<LuniVoiceMessageFinishResponses, LuniVoiceMessageFinishErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LuniVoiceMessageFinishResponses, LuniVoiceMessageFinishErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLuniVoiceMessageFinishResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/voice/message/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hold the empty pair voice slot
 */
export const luniVoiceMessageHold = <ThrowOnError extends boolean = true>(options: Options<LuniVoiceMessageHoldData, ThrowOnError>): RequestResult<LuniVoiceMessageHoldResponses, LuniVoiceMessageHoldErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LuniVoiceMessageHoldResponses, LuniVoiceMessageHoldErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLuniVoiceMessageHoldResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/voice/message/hold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept held audio; transcode in the background, ready via WS
 */
export const luniVoiceMessagePublish = <ThrowOnError extends boolean = true>(options: Options<LuniVoiceMessagePublishData, ThrowOnError>): RequestResult<LuniVoiceMessagePublishResponses, LuniVoiceMessagePublishErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LuniVoiceMessagePublishResponses, LuniVoiceMessagePublishErrors, ThrowOnError, 'data'>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zLuniVoiceMessagePublishResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/voice/message/publish',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Release a voice-slot hold
 */
export const luniVoiceMessageRelease = <ThrowOnError extends boolean = true>(options: Options<LuniVoiceMessageReleaseData, ThrowOnError>): RequestResult<LuniVoiceMessageReleaseResponses, LuniVoiceMessageReleaseErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LuniVoiceMessageReleaseResponses, LuniVoiceMessageReleaseErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLuniVoiceMessageReleaseResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/voice/message/release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Presigned GET URL for a ready voice message
 */
export const luniVoiceMessageUrl = <ThrowOnError extends boolean = true>(options: Options<LuniVoiceMessageUrlData, ThrowOnError>): RequestResult<LuniVoiceMessageUrlResponses, LuniVoiceMessageUrlErrors, ThrowOnError, 'data'> => (options.client ?? client).get<LuniVoiceMessageUrlResponses, LuniVoiceMessageUrlErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLuniVoiceMessageUrlResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/voice/message/url',
    ...options
});

/**
 * WebSocket upgrade
 *
 * Realtime board, presence, friend search results, notifications, voice events, and public stream chat. JWT via Authorization bearer header, query `?token=`, or `access_token` cookie.
 */
export const getApiV1Ws = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1WsData, ThrowOnError>): RequestResult<unknown, GetApiV1WsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<unknown, GetApiV1WsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ws',
    ...options
});

/**
 * Legacy board notifications
 */
export const legacyNotifications = <ThrowOnError extends boolean = true>(options: Options<LegacyNotificationsData, ThrowOnError>): RequestResult<LegacyNotificationsResponses, LegacyNotificationsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<LegacyNotificationsResponses, LegacyNotificationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLegacyNotificationsResponse2.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/{user_id}',
    ...options
});

/**
 * Get online users
 */
export const onlineUsers = <ThrowOnError extends boolean = true>(options?: Options<OnlineUsersData, ThrowOnError>): RequestResult<OnlineUsersResponses, OnlineUsersErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<OnlineUsersResponses, OnlineUsersErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zOnlineUsersResponse2.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/online-users',
    ...options
});

/**
 * Get user status
 */
export const userStatus = <ThrowOnError extends boolean = true>(options: Options<UserStatusData, ThrowOnError>): RequestResult<UserStatusResponses, UserStatusErrors, ThrowOnError, 'data'> => (options.client ?? client).get<UserStatusResponses, UserStatusErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUserStatusResponse2.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user-status/{user_id}',
    ...options
});
